import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import Privilege from "./Privilege";



function Parents(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({  

        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
            
        umowa: '1',    
        dostep: '_x_'  ,

        
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true, 
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);





    const tabRef = useRef(0); //do druku


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'Brak dostępu',
            filter: {  filed: "dostep", set: "2", typ: "combo"  },
        },
    ]);




    //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------


const getTab = () => {
       
 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_access,parents', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result);            


                    var newSelector = [];

                    res.result.forEach( (item) => {
                        newSelector.push({
                            id: item.id,
                            title: item.imie  + "  " + item.nazwisko,
                            selected: 0,
                        });
                    } )

                    setSelectedRow(newSelector);


                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}



const valChangeListener = (filedName, val, correct, msg) => {

    // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

     setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
     
     if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
        {
                var defTimeOut = 1000;
                if(msg == 'combo') defTimeOut = 10;
                clearTimeout(AppContext.timeoutId);
                AppContext.timeoutId = setTimeout( () => {
                    setTab(null); 
                } , defTimeOut );
        }

     props.mainView.writeFilter(filedName, val);
 }


 const goNextNew = () => {
     console.log("goNext");    
     setTab(null);    
 }

 const filterView = () => {
    setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
}


 const filterClear = () => {
 
     props.mainView.writeFilter('r_imie_nazwisko', '');
     props.mainView.writeFilter('d_imie_nazwisko', '');
     props.mainView.writeFilter('p_grupa_id', '_x_');
    
 

     setFilterParam({
       
        r_imie_nazwisko: '', 
        d_imie_nazwisko: '', 
        p_grupa_id: '_x_', 
   
         umowa: '1',   
         dostep: '_x_'  ,         

         
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

         limit: 50,
         page: 1,
         show: true,
     });
     setTab(null);
 }

 const filterApprove = () => {   
     setTab(null)     
 }

 const onChangePagger = (x_limit, x_page) => {

     setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
     setTab(null);
 }

 const onChangeSortBy = (sortBy) => {

    setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
    setTab(null);
}


const changeView = (e ) => {
    var v = e.target.getAttribute('v');
    var id = e.target.getAttribute('id');

    setView({...view, ["v"]:v, ["id"]:id });
}




 const sendPasswordMass = (e) =>
    {         
        var ids = new Array();

        var how = e.target.getAttribute('atr-typ');

    
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej osoby' ,  "ok"  ,null); 
            return;              
         }
    
    

        props.mainView.showDialog("Potwierdź", "Na pewno chcesz wysłać nowe hasło do logowania?", "yesno", (option)=>{
              
            ///--------
            if(option == "yes")
            {
                        props.mainView.setProgress(-2);
    
                        var req = {
                            ids: ids,  
                            typ: 'p'     ,
                            how: how,                            
                        }
    
                        fetch( Config.url + '/rest_v1_access,send', {
                            method: 'POST', 
                            body: JSON.stringify(req), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => { 
    
                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {   
                                        if(res.result > 0)   
                                        {
                                            props.mainView.showDialog( "Sukces", "Dane zostały wysłane"  , "ok" , null);  
                                            getTab();                               
                                        }
                                                
                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });
            }//koniec yes
            //--------
        } );
    
    }    



    const sendAllow = (e) =>
        {         
            var ids = new Array();
        
            for(var k=0; k<selectedRow.length; k++)
                {
                   if( selectedRow[k].selected == 1)
                   {
                        ids.push({
                            id: selectedRow[k].id,
                            title: selectedRow[k].title
                        });
                   }
                }
            
        
             if(ids.length < 1)     
             {       
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej osoby' ,  "ok"  ,null); 
                return;              
             }
        
        
            props.mainView.showDialog("Potwierdź", "Na pewno chcesz nadać dostęp i zezwolić na logowanie?", "yesno", (option)=>{
                  
                ///--------
                if(option == "yes")
                {
                            props.mainView.setProgress(-2);
        
                            var req = {
                                ids: ids,    
                                typ: 'p'                        ,
                            }
        
                            fetch( Config.url + '/rest_v1_access,allow', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
        
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {      
                                            props.mainView.showDialog( "Sukces", "Operacja zakończona sukcesem"  , "ok" , null);                               
                                            getTab();            
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
                }//koniec yes
                //--------
            } );
        
        }    


    const sendDeny= (e) =>
            {         
                var ids = new Array();
            
                for(var k=0; k<selectedRow.length; k++)
                    {
                       if( selectedRow[k].selected == 1)
                       {
                            ids.push({
                                id: selectedRow[k].id,
                                title: selectedRow[k].title
                            });
                       }
                    }
                
            
                 if(ids.length < 1)     
                 {       
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej osoby' ,  "ok"  ,null); 
                    return;              
                 }
            
            
                props.mainView.showDialog("Potwierdź", "Na pewno chcesz zablokować dostęp do panelu i aplikacji?", "yesno", (option)=>{
                      
                    ///--------
                    if(option == "yes")
                    {
                                props.mainView.setProgress(-2);
            
                                var req = {
                                    ids: ids,     
                                    typ: 'p'                        
                                }
            
                                fetch( Config.url + '/rest_v1_access,deny', {
                                    method: 'POST', 
                                    body: JSON.stringify(req), 
                                    headers: {
                                        'Content-Type': 'application/json',                    
                                        'X-Api-Key': props.userData.apiKey,
                                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                                        '_sec_key_': Config.genXKey() ,
                                    }
                                })
                                .then(res => res.json() )
                                .then(res => { 
            
                                            props.mainView.setProgress(-1);        
                                            if(res._sys_ == undefined)
                                            {
                                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                            }else
                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                            {
                                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                            }else    
                                            {      
                                                props.mainView.showDialog( "Sukces", "Operacja zakończona sukcesem"   , "ok" , null);                               
                                                getTab();            
                                            }
                                } )
                                .catch(err => {          
                                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                            props.mainView.setProgress(-1);
                                });
                    }//koniec yes
                    //--------
                } );
            
            }    
    

    const onBack = () => {
          setTab(null);
          setView( {
                v:'list',
                id: -1
           });
       }              


 if(tab == null)
    {
        setTab([]);
        getTab();
     

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }



    var itemsStanyUmowy = [
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '1',
            title: 'Umowa zawarta, generuj rozliczenia'
        },
        {
            v: '2',
            title: 'Umowa rozwiązana'
        },
         
    ];



    var itemsStatus = [
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '1',
            title: 'Pokaż osoby, które mogą się logować'
        },
        {
            v: '2',
            title: 'Pokaż osoby, które nie mogą się logować'
        },
         
    ];



    var zaznaczonych = 0;
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) zaznaczonych ++;
    }


    var sortList = [ 
        {column: "rodzic_nazwisko", name: "Rodzic"  }, 
    ]



    if(view.v == "privilege")
        {
            var searchRow = null;
            for(var k=0; k<tab.length; k++)
            {
                if(tab[k].id == view.id) { searchRow = tab[k]; break; }
            }
    
            return <Privilege   userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}  />
        }




    return (

        <div className="view_content">
           

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 

                {
                    filterParam.show == true  &&
                                <div className="table_filter">

                        
                                <div className="filter_controll">   
                                            <label>Grupa: </label>                             
                                            <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                                        </div> 

                                    <div className="filter_controll">   
                                        <label>Rodzic: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                                    </div>  

                                    <div className="filter_controll">   
                                        <label>Dziecko: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                                    </div>  


                                    <div className="filter_controll">   
                                    <label>Stan umowy dziecka: </label>                             
                                    <InputCombo  items={itemsStanyUmowy}  userData={props.userData}  mainView={props.mainView}  value={filterParam.umowa}   valChange={valChangeListener} goNext={goNextNew} name="umowa"    />
                                </div> 

                                <div className="filter_controll">   
                                    <label>Status: </label>                             
                                    <InputCombo  items={itemsStatus}  userData={props.userData}  mainView={props.mainView}  value={filterParam.dostep}   valChange={valChangeListener} goNext={goNextNew} name="dostep"    />
                                </div> 

                                <div className="filter_btn">
                                    <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                </div>

                    </div>
                } 

                   



                    <div className="bg_center">

                                <div className="table_widget">                                    

                                        <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                            
                                        <InputLegend items={legend}  valChange={valChangeListener} />

                                        <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                                </div>


                                <div className="table_mass">  
                                        <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>

                                        

                                        &nbsp;
                                        <span className="btn" onClick={sendDeny} > Zablokuj zaznaczonego użytk.</span>    
                                    
                                        &nbsp;
                                        <span className="btn" onClick={sendPasswordMass} atr-typ="email"  >Nadaj dostęp i wyślij nowe hasło (E-MAIL)</span>  
                                        &nbsp;                                                          
                                        <span className="btn" onClick={sendPasswordMass} atr-typ="sms"  >Nadaj dostęp i wyślij nowe hasło (SMS)</span>                                                            

                                        <br/>
                                        <br/>
                                        <div className="amount_minus">
                                            Uwaga: Hasło dostępu najlepiej wysłać e-mailem LUB sms-em.  W przypadku wysyłki każdą z tych opcji zostanie wygenerowane dwa razy nowe hasło. Tylko ostatnie będzie tym właściwym. 
                                        </div>
                                </div>

                            <div className="scorll_x">
                                <table className="table" ref={tabRef}>

                                        <thead>
                                                <tr className="header">
                                                    <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>   
                                                    <td>LP</td>                                                                                       
                                                    <td>Może się logować?</td>                                                                                       
                                                    <td>Login</td>                                                                                       
                                                    <td>Nazwisko, imię</td>
                                                    <td>E-mail</td>
                                                    <td>Telefon</td>
                                                    <td>Dzieci</td>
                                                    <td className="td_right">Ostatnia aktywność</td>
                                                    <td className="td_option"></td>
                                                                                             
                                                </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map(  (row, ix) => {


                                                        var isChecked = "";

                                                        var cls = "color_deleted";
                                                        if(row.aktywny == '1') cls = "";


                                                        var aktywny = "Nie";
                                                        if(row.aktywny == 1) aktywny = "Tak";


                                                        for(var s=0; s<selectedRow.length; s++)
                                                            {
                                                                if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                            }

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";


                                                        return <tr className={rowStyle + cls } key={ix}>

                                                                <td className="gocenter">
                                                                   <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                                </td>  

                                                                <td className="gocenter">{ix+1}</td>                                       
                                                                <td className="gocenter">{aktywny}</td>                                       
                                                                <td className="gocenter">{row.username}</td>                                       
                                                                <td>{row.nazwisko + " " + row.imie} </td>
                                                                <td> {row.e_mail } </td>
                                                                <td> {row.telefon} </td>
                                                                <td>

                                                                    {
                                                                        row.dzieci.map( (dz, iy) => {
                                                                            return <span>
                                                                                  {dz.imie + " " + dz.nazwisko} ({dz.grupa}), 
                                                                            </span>
                                                                        } )
                                                                    }

                                                                </td>
                                                                <td className="gocenter">{row.ostatnia_aktywnosc}</td>   

                                                                <MenuTable>
                                                                  <ul>                                                                      
                                                                    <li  onClick={changeView} v="privilege" id={row.id}  >uprawnienia</li>                                                                         
                                                                  </ul>                                                               
                                                                </MenuTable>  
                                                        
                                                        </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>
                            </div>

                    </div>

        </div>
    )


}

export default Parents;